/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
// import { useDispatch, useSelector } from 'react-redux';
import * as uuid from "uuid";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

// import AdminNavbar from "components/Navbars/AdminNavbar";
// import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import SidebarToggle from "components/SidebarToggle";
import LoginForm from 'components/LoginForm';
// import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import ScrollToTop from "react-scroll-to-top";
import FloatingBugReport from "components/FloatingBugReport/FloatingBugReport";

import routes from "routes.js";
import { hasAccess } from "routes.js";

import sidebarImage from "assets/img/sidebar-3.jpg";
import { Component } from 'react';
import { connect } from "react-redux";
import { getUser } from '../actions';
import { Tooltip } from 'reactstrap';

class Admin extends Component {
  constructor() {
    super();
    this.state = {
      showModalLogin: false,
      color: 'black',
      hasImage: true,
      image: sidebarImage,
      tooltipOpen: false
    };

    // this.mainPanel = React.useRef(null);
  }

  // const [image, setImage] = React.useState(sidebarImage);
  // const [color, setColor] = React.useState("black");
  // const [hasImage, setHasImage] = React.useState(true);
  // const location = useLocation();
  // const 

  getRoutes = (routes) => {
    let allRoutes = []; // Initialize an array to hold all routes
    const userGroups = this.props.user?.groups;

    routes.forEach((prop) => {
      if (prop.layout === "/admin" && hasAccess(prop, userGroups)) {
        // If it's a direct route in the layout
        if (prop.component) { // Check if it has a component to render
          allRoutes.push(
            <Route
              path={prop.layout + prop.path}
              render={(props) => {
                // Add query parameters to props
                const queryParams = prop.query || {};
                return <prop.component {...props} {...queryParams} />;
              }}
              key={uuid.v4()} // Use unique key
            />
          );
        }

        // If it has children, recursively get their routes
        if (prop.children && prop.children.length > 0) {
          const childRoutes = this.getRoutes(prop.children); // Recursive call
          allRoutes = allRoutes.concat(childRoutes); // Add child routes to the list
        }
      }
    });

    return allRoutes; // Return the combined list of routes
  };

  componentDidMount(){
    this.props.getUser();
  }

  componentWillReceiveProps(props) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    // this.mainPanel.current.scrollTop = 0;

    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
  }

  render() {
    const viewSoldChart = window.location.hostname.includes("resin");

    return (
      <>
        <div className="wrapper">
          <Sidebar
            color={this.state.color}
            image={this.state.hasImage ? this.state.image : ""}
            routes={routes}
          />
          <SidebarToggle />
          {!this.props.user? <LoginForm />:
            <div className="main-panel" ref={this.mainPanel} style={viewSoldChart? {width: "100%"}: {}}>
              <div className="content">
                <Switch>{this.getRoutes(routes)}</Switch>
              </div>
            </div>
          }
        </div>
        <FloatingBugReport />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authenReducer.user
  };
};

export default connect(mapStateToProps, { getUser })(Admin);
